import { useState, useRef } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

const allTickets = [
  { id: 'IT-001', type: 'IT', category: 'New Employee Setup', subject: 'New hire setup - Jamie Mitchell', priority: 'High', status: 'Open', submittedBy: 'HR - Tiffany Gallagher', assignedTo: 'John Gallagher', created: 'Apr 2, 2025', updated: 'Apr 2, 2025',
    description: 'New employee Jamie Mitchell starts Jan 12. Needs full workstation setup, email account, system access, and badge.',
    items: ['Laptop - Dell Latitude 15"', 'Monitor x2', 'Keyboard & Mouse', 'Company email: j.mitchell@democompany.co', 'Badge & Building Access', 'VPN Access', 'MS Office License'],
    programCode: 'HR-ONBOARD-2025', approvedBy: 'Tiffany Gallagher', autoGenerated: true,
    messages: [{ author: 'John Gallagher', text: 'Laptop ordered, ETA 3 days. Will set up email today.', time: 'Apr 2, 10:30am', type: 'reply', delivery: 'portal' }]},
  { id: 'IT-002', type: 'IT', category: 'Equipment Request', subject: 'Replacement keyboard - Sam Rivera', priority: 'Low', status: 'Open', submittedBy: 'Sam Rivera', assignedTo: 'Unassigned', created: 'Apr 1, 2025', updated: 'Apr 1, 2025',
    description: 'Current keyboard has several stuck keys. Requesting replacement.',
    items: ['Keyboard/Mouse - Windows'], programCode: 'OPS-EQUIP-2025', approvedBy: 'Tiffany Gallagher', autoGenerated: false, messages: []},
  { id: 'IT-003', type: 'IT', category: 'Software', subject: 'VPN not connecting - Marcus Thomas', priority: 'Urgent', status: 'In Progress', submittedBy: 'Marcus Thomas', assignedTo: 'John Gallagher', created: 'Mar 31, 2025', updated: 'Apr 1, 2025',
    description: 'Unable to connect to VPN since Mar 31. Getting error code 0x800704B3.',
    items: [], programCode: '', approvedBy: '', autoGenerated: false,
    messages: [
      { author: 'John Gallagher', text: 'Checked logs - certificate expiry issue. Pushing fix remotely now.', time: 'Apr 1, 2:15pm', type: 'reply', delivery: 'portal' },
      { author: 'John Gallagher', text: 'Internal note: May need to update cert on server side too. Checking with vendor.', time: 'Apr 1, 2:45pm', type: 'note', delivery: 'none' },
    ]},
  { id: 'IT-004', type: 'IT', category: 'New Employee Setup', subject: 'New hire setup - Jordan Collins', priority: 'High', status: 'Resolved', submittedBy: 'HR - Tiffany Gallagher', assignedTo: 'John Gallagher', created: 'Oct 28, 2023', updated: 'Nov 1, 2023',
    description: 'New employee Jordan Collins starts Nov 1. Standard setup package.',
    items: ['Laptop - Windows', 'Company Email', 'Badge Access'], programCode: 'HR-ONBOARD-2023', approvedBy: 'Tiffany Gallagher', autoGenerated: true, messages: []},
  { id: 'FAC-001', type: 'Facilities', category: 'Building Access', subject: 'Badge access - Jamie Mitchell', priority: 'High', status: 'Open', submittedBy: 'HR - Tiffany Gallagher', assignedTo: 'Facilities Team', created: 'Apr 2, 2025', updated: 'Apr 2, 2025',
    description: 'New employee Jamie Mitchell needs badge programming for main entrance, Operations wing, and parking garage.',
    items: ['Main entrance access', 'Operations wing - Level 2', 'Parking garage', 'Break room'], programCode: 'HR-ONBOARD-2025', approvedBy: 'Tiffany Gallagher', autoGenerated: true, messages: []},
  { id: 'FAC-002', type: 'Facilities', category: 'Maintenance', subject: 'HVAC issue - Operations office', priority: 'Urgent', status: 'In Progress', submittedBy: 'Kim Park', assignedTo: 'Facilities Team', created: 'Apr 1, 2025', updated: 'Apr 2, 2025',
    description: 'HVAC making loud grinding noise. Temperature fluctuating 65-80F.',
    items: [], programCode: '', approvedBy: '', autoGenerated: false,
    messages: [{ author: 'Facilities Team', text: 'Technician scheduled Apr 3, 8-10am.', time: 'Apr 2, 9:00am', type: 'reply', delivery: 'email' }]},
  { id: 'FAC-003', type: 'Facilities', category: 'Supplies', subject: 'Office supplies restock', priority: 'Low', status: 'Pending', submittedBy: 'Dana Lee', assignedTo: 'Unassigned', created: 'Mar 30, 2025', updated: 'Mar 30, 2025',
    description: 'Break room coffee station needs restock. Printer paper for Field Staff.',
    items: ['Coffee pods x50', 'Printer paper x2 reams', 'Paper towels x4'], programCode: 'FAC-SUPPLIES-2025', approvedBy: '', autoGenerated: false, messages: []},
  { id: 'FAC-004', type: 'Facilities', category: 'Workspace', subject: 'Standing desk - Kim Park', priority: 'Medium', status: 'Closed', submittedBy: 'Kim Park', assignedTo: 'Facilities Team', created: 'Mar 15, 2025', updated: 'Mar 20, 2025',
    description: 'Standing desk conversion kit for workstation. Doctor note on file.',
    items: ['Standing desk converter'], programCode: 'FAC-WORKSPACE-2025', approvedBy: 'Tiffany Gallagher', autoGenerated: false, messages: []},
]

const techOptions = ['Unassigned', 'John Gallagher', 'Facilities Team', 'IT Support', 'Tiffany Gallagher']
const statusOptions = ['Open', 'In Progress', 'Pending', 'Resolved', 'Closed', 'Escalated to CR']

const itCategories = ['Hardware Issue', 'Software', 'Equipment Request', 'Network / Connectivity', 'Account / Access', 'New Employee Setup', 'Other']
const facCategories = ['Building Access', 'Maintenance', 'Supplies', 'Workspace', 'Safety', 'Cleaning', 'Other']
const softwareSubcats = ['Software Request', 'Software Issue', 'License / Access', 'Other']

const blankTicket = (type) => ({
  type, category: '', softwareSubcat: '', subject: '', description: '',
  priority: 'Medium', assignedTo: type==='IT'?'John Gallagher':'Facilities Team',
  fundingSource: '', approvedBy: '',
})

export default function Helpdesk() {
  const { accent, accentBg } = useBrandColors()
  const [queue, setQueue] = useState('IT')
  const [statusFilter, setStatusFilter] = useState('All')
  const [selectedTicket, setSelectedTicket] = useState(null)
  const [newMessage, setNewMessage] = useState('')
  const [messageType, setMessageType] = useState('reply')
  const [messageDelivery, setMessageDelivery] = useState('portal')
  const [tickets, setTickets] = useState(allTickets)
  const [toast, setToast] = useState(null)
  const [showNewTicket, setShowNewTicket] = useState(false)
  const [newTicketType, setNewTicketType] = useState('IT')
  const [newTicket, setNewTicket] = useState(blankTicket('IT'))
  const [attachments, setAttachments] = useState([])
  const fileRef = useRef()

  const priorityColor = { Urgent:'#A0392B', High:'#C4843A', Medium:'#4A6B8A', Low:'#6B7D6B' }
  const statusColor   = { Open:'#C4843A', 'In Progress':'#4A6B8A', Pending:'#8A6A2A', Resolved:'#4A7C59', Closed:'#8A9E8A' }
  const deliveryColor = { portal: accent, email: '#4A6B8A', none: '#8A9E8A' }
  const deliveryLabel = { portal: 'Portal', email: 'Email', none: '' }

  const queueTickets = tickets.filter(t => t.type === queue)
  const filtered = queueTickets.filter(t => statusFilter === 'All' || t.status === statusFilter)
  const countBy = (type, status) => tickets.filter(t=>t.type===type&&t.status===status).length
  const urgentCount = (type) => tickets.filter(t=>t.type===type&&t.priority==='Urgent'&&t.status!=='Closed'&&t.status!=='Resolved').length

  function updateField(ticketId, field, value) {
    setTickets(ts => ts.map(t => t.id===ticketId ? {...t, [field]:value} : t))
    if (selectedTicket?.id === ticketId) setSelectedTicket(t => ({...t, [field]:value}))
    if (field === 'status') showToast(`Ticket ${ticketId} marked as ${value}`)
    if (field === 'assignedTo' && value !== 'Unassigned') showToast(`Ticket ${ticketId} assigned to ${value}`)
  }

  function addMessage() {
    if (!newMessage.trim()) return
    const msg = {
      author: 'Tiffany Gallagher',
      text: newMessage,
      time: 'Just now',
      type: messageType,
      delivery: messageType === 'note' ? 'none' : messageDelivery,
      attachments: attachments.map(a => a.name),
    }
    setTickets(ts => ts.map(t => t.id===selectedTicket.id ? {...t, messages:[...t.messages, msg]} : t))
    setSelectedTicket(t => ({...t, messages:[...t.messages, msg]}))
    setNewMessage('')
    setAttachments([])
    if (messageType === 'reply') showToast(`Reply sent via ${messageDelivery === 'portal' ? 'Portal Memo' : 'Email'}`)
    else showToast('Internal note saved')
  }

  function handleFileSelect(e) {
    const files = Array.from(e.target.files)
    setAttachments(prev => [...prev, ...files])
    e.target.value = ''
  }

  function submitNewTicket() {
    if (!newTicket.category || !newTicket.subject || !newTicket.description) {
      alert('Please fill in Category, Subject, and Description.')
      return
    }
    const id = newTicket.type === 'IT'
      ? 'IT-' + String(tickets.filter(t=>t.type==='IT').length + 1).padStart(3,'0')
      : 'FAC-' + String(tickets.filter(t=>t.type==='Facilities').length + 1).padStart(3,'0')
    const ticket = {
      ...newTicket, id,
      status: 'Open',
      submittedBy: 'Tiffany Gallagher',
      created: 'Apr 10, 2025',
      updated: 'Apr 10, 2025',
      items: [],
      autoGenerated: false,
      messages: [],
    }
    setTickets(ts => [...ts, ticket])
    setShowNewTicket(false)
    setNewTicket(blankTicket('IT'))
    setQueue(newTicket.type)
    showToast(`Ticket ${id} created successfully`)
  }

  function escalateToCR(ticketId) {
    updateTicket(ticketId, 'status', 'Escalated to CR')
    showToast('Ticket ' + ticketId + ' escalated to Change Request — create a CR in IT Change Management')
  }
  function showToast(msg) {
    setToast(msg)
    setTimeout(()=>setToast(null), 3500)
  }

  const inputStyle = { width:'100%', padding:'8px 10px', border:'1px solid #EDE6DA', borderRadius:6, fontSize:12, fontFamily:"'Montserrat',sans-serif", outline:'none', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:9, textTransform:'uppercase', letterSpacing:'0.1em', color:'#6B7D6B', fontWeight:600, marginBottom:5 }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {/* Toast */}
      {toast && (
        <div style={{position:'fixed',top:20,right:24,zIndex:2000,background:'#2B2B2B',color:'#fff',padding:'12px 18px',borderRadius:8,fontSize:12,fontWeight:500,boxShadow:'0 4px 20px rgba(0,0,0,0.2)',display:'flex',alignItems:'center',gap:10}}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          {toast}
        </div>
      )}

      {/* New Ticket Modal */}
      {showNewTicket && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:600,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowNewTicket(false)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:560,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,0.2)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#2B2B2B',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#fff'}}>New Ticket</div>
              <button onClick={()=>setShowNewTicket(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'rgba(255,255,255,0.5)',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:14}}>
              <div style={{display:'flex',gap:8}}>
                {['IT','Facilities'].map(t=>(
                  <button key={t} onClick={()=>{setNewTicketType(t);setNewTicket(blankTicket(t))}}
                    style={{flex:1,padding:'8px',border:newTicketType===t?`2px solid ${accent}`:'2px solid #EDE6DA',borderRadius:6,background:newTicketType===t?accentBg:'#fff',color:newTicketType===t?accent:'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                    {t === 'IT' ? 'IT Ticket' : 'Facilities Ticket'}
                  </button>
                ))}
              </div>
              <div>
                <label style={labelStyle}>Category *</label>
                <select value={newTicket.category} onChange={e=>setNewTicket(n=>({...n,category:e.target.value,softwareSubcat:''}))} style={inputStyle}>
                  <option value="">Select category...</option>
                  {(newTicketType==='IT'?itCategories:facCategories).map(c=><option key={c}>{c}</option>)}
                </select>
              </div>
              {newTicket.category === 'Software' && (
                <div>
                  <label style={labelStyle}>Software Type *</label>
                  <select value={newTicket.softwareSubcat} onChange={e=>setNewTicket(n=>({...n,softwareSubcat:e.target.value}))} style={inputStyle}>
                    <option value="">Select type...</option>
                    {softwareSubcats.map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>
              )}
              <div>
                <label style={labelStyle}>Subject *</label>
                <input value={newTicket.subject} onChange={e=>setNewTicket(n=>({...n,subject:e.target.value}))} placeholder="Brief description" style={inputStyle}/>
              </div>
              <div>
                <label style={labelStyle}>Description *</label>
                <textarea value={newTicket.description} onChange={e=>setNewTicket(n=>({...n,description:e.target.value}))} rows={4} placeholder="Provide as much detail as possible..." style={{...inputStyle,resize:'vertical'}}/>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <label style={labelStyle}>Priority</label>
                  <select value={newTicket.priority} onChange={e=>setNewTicket(n=>({...n,priority:e.target.value}))} style={inputStyle}>
                    {['Low','Medium','High','Urgent'].map(p=><option key={p}>{p}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Assign To</label>
                  <select value={newTicket.assignedTo} onChange={e=>setNewTicket(n=>({...n,assignedTo:e.target.value}))} style={inputStyle}>
                    {techOptions.map(o=><option key={o}>{o}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Funding Source</label>
                  <input value={newTicket.fundingSource} onChange={e=>setNewTicket(n=>({...n,fundingSource:e.target.value}))} placeholder="e.g. OPS-2025" style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Approved By</label>
                  <input value={newTicket.approvedBy} onChange={e=>setNewTicket(n=>({...n,approvedBy:e.target.value}))} placeholder="Approver name" style={inputStyle}/>
                </div>
              </div>
              <div style={{display:'flex',justifyContent:'flex-end',gap:10,paddingTop:4,borderTop:'1px solid #EDE6DA'}}>
                <button onClick={()=>setShowNewTicket(false)} style={{padding:'8px 18px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
                <button onClick={submitNewTicket} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Create Ticket</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Ticket Detail Modal */}
      {selectedTicket && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setSelectedTicket(null)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:680,maxHeight:'92vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,0.2)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'flex-start',background:'#F7F2EB',borderRadius:'12px 12px 0 0'}}>
              <div>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                  <span style={{fontSize:11,fontWeight:700,color:'#8A9E8A'}}>{selectedTicket.id}</span>
                  {selectedTicket.autoGenerated && <span style={{fontSize:9,padding:'2px 6px',borderRadius:8,background:accentBg,color:accent,fontWeight:600}}>AUTO-GENERATED</span>}
                  <span style={{fontSize:11,padding:'3px 10px',borderRadius:20,fontWeight:600,background:statusColor[selectedTicket.status]+'22',color:statusColor[selectedTicket.status]}}>{selectedTicket.status}</span>
                  <span style={{fontSize:11,padding:'3px 10px',borderRadius:20,fontWeight:600,background:priorityColor[selectedTicket.priority]+'22',color:priorityColor[selectedTicket.priority]}}>{selectedTicket.priority}</span>
                </div>
                <div style={{fontFamily:'Georgia,serif',fontSize:17,fontWeight:600,color:'#2B2B2B'}}>{selectedTicket.subject}</div>
                <div style={{fontSize:11,color:'#8A9E8A',marginTop:3}}>{selectedTicket.category} &middot; {selectedTicket.submittedBy} &middot; {selectedTicket.created}</div>
              </div>
              <button onClick={()=>setSelectedTicket(null)} style={{background:'none',border:'none',fontSize:22,cursor:'pointer',color:'#8A9E8A',lineHeight:1,flexShrink:0}}>&times;</button>
            </div>

            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:16}}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <div style={labelStyle}>Assigned To</div>
                  <select value={selectedTicket.assignedTo} onChange={e=>updateField(selectedTicket.id,'assignedTo',e.target.value)}
                    style={{width:'100%',padding:'7px 10px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none'}}>
                    {techOptions.map(t=><option key={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <div style={labelStyle}>Status</div>
                  <select value={selectedTicket.status} onChange={e=>updateField(selectedTicket.id,'status',e.target.value)}
                    style={{width:'100%',padding:'7px 10px',border:`1px solid ${statusColor[selectedTicket.status]}`,borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:statusColor[selectedTicket.status],fontWeight:600}}>
                    {statusOptions.map(s=><option key={s}>{s}</option>)}
                  </select>
                </div>
              </div>

              <div style={{background:'#F7F2EB',borderRadius:8,padding:'14px 16px'}}>
                <div style={labelStyle}>Description</div>
                <div style={{fontSize:13,color:'#4A4A4A',lineHeight:1.7}}>{selectedTicket.description}</div>
              </div>

              {selectedTicket.items.length > 0 && (
                <div>
                  <div style={labelStyle}>Items Requested</div>
                  {selectedTicket.items.map((item,i)=>(
                    <div key={i} style={{display:'flex',alignItems:'center',gap:8,padding:'6px 0',borderBottom:i<selectedTicket.items.length-1?'1px solid #EDE6DA':'none'}}>
                      <div style={{width:6,height:6,borderRadius:'50%',background:accent,flexShrink:0}}></div>
                      <span style={{fontSize:12,color:'#4A4A4A'}}>{item}</span>
                    </div>
                  ))}
                </div>
              )}

              {(selectedTicket.programCode || selectedTicket.approvedBy) && (
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                  {selectedTicket.programCode && (
                    <div style={{padding:'10px 14px',background:'rgba(74,107,138,0.06)',border:'1px solid rgba(74,107,138,0.15)',borderRadius:8}}>
                      <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#4A6B8A',fontWeight:600,marginBottom:3}}>Funding Source</div>
                      <div style={{fontSize:13,color:'#2B2B2B',fontWeight:600}}>{selectedTicket.programCode}</div>
                    </div>
                  )}
                  {selectedTicket.approvedBy && (
                    <div style={{padding:'10px 14px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.15)',borderRadius:8}}>
                      <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#4A7C59',fontWeight:600,marginBottom:3}}>Approved By</div>
                      <div style={{fontSize:13,color:'#2B2B2B',fontWeight:600}}>{selectedTicket.approvedBy}</div>
                    </div>
                  )}
                </div>
              )}

              {/* Activity */}
              <div>
                <div style={labelStyle}>Activity</div>
                {selectedTicket.messages.length === 0
                  ? <div style={{fontSize:12,color:'#8A9E8A',fontStyle:'italic',marginBottom:12}}>No activity yet.</div>
                  : selectedTicket.messages.map((m,i)=>(
                    <div key={i} style={{display:'flex',gap:10,marginBottom:12}}>
                      <div style={{width:28,height:28,borderRadius:'50%',background:m.type==='note'?'rgba(138,106,42,0.15)':accentBg,border:`1.5px solid ${m.type==='note'?'#8A6A2A':accent}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,color:m.type==='note'?'#8A6A2A':accent,flexShrink:0}}>
                        {m.author.split(' ').map(n=>n[0]).join('')}
                      </div>
                      <div style={{flex:1,background:m.type==='note'?'rgba(138,106,42,0.06)':'#F7F2EB',borderRadius:8,padding:'10px 12px',border:m.type==='note'?'1px solid rgba(138,106,42,0.2)':'none'}}>
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:4}}>
                          <div style={{display:'flex',alignItems:'center',gap:6}}>
                            <span style={{fontSize:11,fontWeight:600,color:'#2B2B2B'}}>{m.author}</span>
                            {m.type==='note' && <span style={{fontSize:9,padding:'1px 6px',borderRadius:8,background:'rgba(138,106,42,0.15)',color:'#8A6A2A',fontWeight:600}}>INTERNAL NOTE</span>}
                            {m.type==='reply' && m.delivery && <span style={{fontSize:9,padding:'1px 6px',borderRadius:8,background:deliveryColor[m.delivery]+'22',color:deliveryColor[m.delivery],fontWeight:600}}>via {deliveryLabel[m.delivery]}</span>}
                          </div>
                          <span style={{fontSize:10,color:'#8A9E8A'}}>{m.time}</span>
                        </div>
                        <div style={{fontSize:12,color:'#4A4A4A',lineHeight:1.6}}>{m.text}</div>
                        {m.attachments && m.attachments.length > 0 && (
                          <div style={{marginTop:8,display:'flex',flexWrap:'wrap',gap:6}}>
                            {m.attachments.map((a,j)=>(
                              <span key={j} style={{fontSize:10,padding:'2px 8px',borderRadius:6,background:'rgba(74,107,138,0.08)',color:'#4A6B8A',fontWeight:500}}>&#128206; {a}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                }

                {/* Message type + delivery toggles */}
                <div style={{display:'flex',gap:8,marginBottom:8,flexWrap:'wrap',alignItems:'center'}}>
                  <div style={{display:'flex',border:'1px solid #EDE6DA',borderRadius:6,overflow:'hidden'}}>
                    <button onClick={()=>setMessageType('reply')} style={{padding:'5px 14px',border:'none',background:messageType==='reply'?accent:'#fff',color:messageType==='reply'?'#fff':'#4A4A4A',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Reply to Employee</button>
                    <button onClick={()=>escalateToCR(selected.id)} style={{padding:'5px 14px',border:'none',background:'#4A6B8A',color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",borderRadius:4}}>Escalate to CR</button>
                    <button onClick={()=>setMessageType('note')} style={{padding:'5px 14px',border:'none',borderLeft:'1px solid #EDE6DA',background:messageType==='note'?'#8A6A2A':'#fff',color:messageType==='note'?'#fff':'#4A4A4A',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Internal Note</button>
                  </div>
                  {messageType === 'reply' && (
                    <div style={{display:'flex',border:'1px solid #EDE6DA',borderRadius:6,overflow:'hidden'}}>
                      <button onClick={()=>setMessageDelivery('portal')} style={{padding:'5px 12px',border:'none',background:messageDelivery==='portal'?accentBg:'#fff',color:messageDelivery==='portal'?accent:'#6B7D6B',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>&#128274; Portal Memo</button>
                      <button onClick={()=>setMessageDelivery('email')} style={{padding:'5px 12px',border:'none',borderLeft:'1px solid #EDE6DA',background:messageDelivery==='email'?'rgba(74,107,138,0.08)':'#fff',color:messageDelivery==='email'?'#4A6B8A':'#6B7D6B',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>&#9993; Email</button>
                    </div>
                  )}
                </div>

                <div style={{display:'flex',gap:8,alignItems:'flex-end'}}>
                  <div style={{flex:1}}>
                    <textarea value={newMessage} onChange={e=>setNewMessage(e.target.value)} rows={3}
                      placeholder={messageType==='reply'?`Write a reply (sent via ${messageDelivery==='portal'?'Portal Memo':'Email'})...`:'Add an internal note (not visible to employee)...'}
                      style={{width:'100%',padding:'8px 12px',border:`1px solid ${messageType==='note'?'rgba(138,106,42,0.3)':'#EDE6DA'}`,borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',resize:'none',background:messageType==='note'?'rgba(138,106,42,0.03)':'#fff',boxSizing:'border-box'}}/>
                    {attachments.length > 0 && (
                      <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:6}}>
                        {attachments.map((a,i)=>(
                          <span key={i} style={{display:'flex',alignItems:'center',gap:4,fontSize:10,padding:'2px 8px',borderRadius:6,background:'rgba(74,107,138,0.08)',color:'#4A6B8A'}}>
                            &#128206; {a.name}
                            <button onClick={()=>setAttachments(att=>att.filter((_,j)=>j!==i))} style={{background:'none',border:'none',cursor:'pointer',color:'#A0392B',fontSize:12,lineHeight:1,padding:0}}>&times;</button>
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:6}}>
                    <button onClick={()=>fileRef.current.click()} title="Attach file"
                      style={{padding:'8px 10px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',cursor:'pointer',fontSize:14,color:'#6B7D6B'}}>&#128206;</button>
                    <button onClick={addMessage}
                      style={{padding:'8px 14px',background:messageType==='note'?'#8A6A2A':accent,border:'none',borderRadius:6,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                      {messageType==='reply'?'Send':'Save'}
                    </button>
                  </div>
                  <input ref={fileRef} type="file" multiple style={{display:'none'}} onChange={handleFileSelect}/>
                </div>
              </div>

              <div style={{display:'flex',gap:8,paddingTop:8,borderTop:'1px solid #EDE6DA',flexWrap:'wrap'}}>
                <div style={{fontSize:11,color:'#8A9E8A',alignSelf:'center',marginRight:4}}>Quick actions:</div>
                {statusOptions.filter(s=>s!==selectedTicket.status).map(s=>(
                  <button key={s} onClick={()=>updateField(selectedTicket.id,'status',s)}
                    style={{padding:'6px 12px',border:`1px solid ${statusColor[s]}`,borderRadius:6,background:statusColor[s]+'11',fontSize:11,fontWeight:600,color:statusColor[s],cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Collective Services</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>IT &amp; Facilities ticket management</p>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>{setNewTicketType('IT');setNewTicket(blankTicket('IT'));setShowNewTicket(true)}}
            style={{padding:'8px 16px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ New IT Ticket</button>
          <button onClick={()=>{setNewTicketType('Facilities');setNewTicket(blankTicket('Facilities'));setShowNewTicket(true)}}
            style={{padding:'8px 16px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ New Facilities Ticket</button>
        </div>
      </div>

      {/* Queue switcher */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {['IT','Facilities'].map((q,i)=>(
          <button key={q} onClick={()=>{setQueue(q);setStatusFilter('All')}}
            style={{padding:'8px 28px',border:'none',borderRight:i===0?'1px solid #EDE6DA':'none',background:queue===q?accent:'#fff',color:queue===q?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
            {q === 'IT' ? 'IT Queue' : 'Facilities Queue'}
            {urgentCount(q) > 0 && <span style={{marginLeft:6,background:'#A0392B',color:'#fff',fontSize:9,padding:'1px 5px',borderRadius:8,fontWeight:600}}>{urgentCount(q)} urgent</span>}
          </button>
        ))}
      </div>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:10,marginBottom:16}}>
        {statusOptions.map(s=>(
          <div key={s} onClick={()=>setStatusFilter(statusFilter===s?'All':s)}
            style={{background:'#fff',border:`1px solid ${statusFilter===s?statusColor[s]:'#EDE6DA'}`,borderRadius:10,padding:'10px 14px',cursor:'pointer',transition:'all 0.15s'}}>
            <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:statusFilter===s?statusColor[s]:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s}</div>
            <div style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:statusFilter===s?statusColor[s]:'#2B2B2B',fontWeight:600}}>{countBy(queue,s)}</div>
          </div>
        ))}
      </div>

      {/* Ticket list */}
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {filtered.length === 0 && (
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'40px',textAlign:'center',color:'#8A9E8A',fontSize:13}}>No tickets found.</div>
        )}
        {filtered.map(t=>(
          <div key={t.id} onClick={()=>setSelectedTicket(t)}
            style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px 20px',cursor:'pointer',transition:'all 0.15s'}}
            onMouseEnter={e=>e.currentTarget.style.borderColor=accent}
            onMouseLeave={e=>e.currentTarget.style.borderColor='#EDE6DA'}>
            <div style={{display:'flex',alignItems:'flex-start',gap:14}}>
              <div style={{flex:1}}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:5,flexWrap:'wrap'}}>
                  <span style={{fontSize:11,fontWeight:700,color:'#8A9E8A'}}>{t.id}</span>
                  <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,fontWeight:600,background:priorityColor[t.priority]+'22',color:priorityColor[t.priority]}}>{t.priority}</span>
                  <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,fontWeight:600,background:statusColor[t.status]+'22',color:statusColor[t.status]}}>{t.status}</span>
                  {t.autoGenerated && <span style={{fontSize:9,padding:'2px 6px',borderRadius:8,background:accentBg,color:accent,fontWeight:600}}>AUTO</span>}
                  <span style={{fontSize:10,padding:'2px 8px',borderRadius:8,background:'#F7F2EB',color:'#6B7D6B',fontWeight:500}}>{t.category}</span>
                </div>
                <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B',marginBottom:4}}>{t.subject}</div>
                <div style={{fontSize:11,color:'#8A9E8A'}}>
                  {t.submittedBy} &middot; Assigned: <strong style={{color:t.assignedTo==='Unassigned'?'#A0392B':'#4A4A4A'}}>{t.assignedTo}</strong> &middot; Updated {t.updated}
                </div>
              </div>
              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:6,flexShrink:0}}>
                {t.programCode && <span style={{fontSize:10,padding:'2px 8px',borderRadius:6,background:'rgba(74,107,138,0.08)',color:'#4A6B8A',fontWeight:600}}>{t.programCode}</span>}
                {t.messages.length > 0 && <span style={{fontSize:10,color:'#8A9E8A'}}>&#128172; {t.messages.length}</span>}
                {t.assignedTo === 'Unassigned' && <span style={{fontSize:10,color:'#A0392B',fontWeight:600}}>Needs assignment</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
